/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum FuelControllerConfigurationReadingStatusApiModel {
  ConnectionNotConfigured = 'connection-not-configured',

  ReadyToRead = 'ready-to-read',

  Success = 'success',

  Fail = 'fail'
}
